<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <!-- <el-input v-model="dataForm.key" placeholder="参数名" clearable></el-input> -->
      </el-form-item>
      <el-form-item>
        <!-- <el-button @click="getDataList()">查询</el-button> -->
        <el-button v-if="isAuth('bus:busbrand:save')" type="primary" @click="addOrUpdateHandle()">新增</el-button>
        <el-button v-if="isAuth('bus:busbrand:admin')" type="primary" @click="cutState()">{{showCheck?'查看待审核':'查看已审核'}}</el-button>
        <!-- <el-button v-if="isAuth('bus:busbrand:delete')" type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      :row-class-name="tableRowClassName"
      style="width: 100%;">
      <!-- <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column> -->
      <el-table-column
        prop="sort"
        width="70"
        header-align="center"
        align="center"
        label="排序号">
      </el-table-column>
      <el-table-column
        prop="img"
        header-align="center"
        align="center"
        width="100"
        label="图片" :key="Math.random()">
        <template slot-scope="scope">
          <img style="height:50px" v-if="scope.row.img" :src="$imgPath+scope.row.img" />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="名称">
        <template slot-scope="scope">
          <a v-if="scope.row.link" :href="scope.row.link" target="_blank">{{scope.row.name}}</a>
          <span v-else>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="btn1Nums"
        header-align="center"
        align="center"
        label="一级按钮">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" 
          @click="$router.push('/busbuttons?type=0&brandid='+scope.row.id+'&brandname='+scope.row.name)">
          {{scope.row.btn1Nums}}个</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="btn2Nums"
        header-align="center"
        align="center"
        label="二级按钮">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" 
          @click="$router.push('/busbuttons?type=1&brandid='+scope.row.id+'&brandname='+scope.row.name)">
          {{scope.row.btn2Nums}}个</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="deviceTypeEntity.name"
        header-align="center"
        align="center"
        label="所属类别">
      </el-table-column>
      <el-table-column
        prop="keytype"
        header-align="center"
        align="center"
        label="按钮类型">
        <template slot-scope="scope">
          {{getKeytypeName(scope.row.keytype)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="createSysUser.username"
        header-align="center"
        align="center"
        label="创建者">
      </el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        label="波特率备注">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="250"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-if="isAuth('bus:busbrand:admin') && !showCheck" @click="check(scope.row.id,1)">审核</el-button>
          <el-button type="text" size="small" v-if="isAuth('bus:busbrand:admin') && showCheck" @click="check(scope.row.id,0)">取消审核</el-button>
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
          <el-button type="text" size="small" @click="copyHandle(scope.row.id)">复制</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
  import AddOrUpdate from './busbrand-add-or-update'
  export default {
    data () {
      return {
        dataForm: {
          key: ''
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false,
        showCheck: true,
        keytypeData: []
      }
    },
    components: {
      AddOrUpdate
    },
    activated () {
      this.getDataList()
    },
    mounted() {
      this.getKeytypeData()
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        if (row.isextend === 1) {
          return 'extend-row'
        }
        return ''
      },
      cutState() {
        this.showCheck = !this.showCheck
        this.getDataList()
      },
      // 获取按钮类型名称
      getKeytypeName(v) {
        for (var item of this.keytypeData) {
          if (item.id === v) {
            return item.name
          }
        }
      },
      getKeytypeData() {
        this.$http({
          url: this.$http.adornUrl('/bus/busdata/list/keyType'),
          method: 'post',
          data: this.$http.adornData({})
        }).then(({data}) => {
          if (data && data.code === 0) {
            for (var row of data.list) {
              row.data = JSON.parse(row.data)
            }
            this.keytypeData = data.list
          }
        })
      },
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        this.$http({
          url: this.$http.adornUrl('/bus/busbrand/list'),
          method: 'get',
          params: this.$http.adornParams({
            'page': this.pageIndex,
            'limit': this.pageSize,
            'key': this.dataForm.key,
            'state': this.isAuth('bus:busbrand:admin') ? (this.showCheck ? 1 : 0) : null
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = data.page.list
            this.totalPage = data.page.totalCount
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addOrUpdateHandle (id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id)
        })
      },
      check(id, v) {
        this.$http({
          url: this.$http.adornUrl('/bus/busbrand/update'),
          method: 'post',
          data: this.$http.adornData({
            'id': id,
            'state': v
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      // 复制
      copyHandle(id) {
        this.$confirm('是否确定复制？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl('/bus/busbrand/copy'),
            method: 'post',
            data: this.$http.adornData(id, false)
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      },
      // 删除
      deleteHandle (id) {
        var ids = id ? [id] : this.dataListSelections.map(item => {
          return item.id
        })
        this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl('/bus/busbrand/delete'),
            method: 'post',
            data: this.$http.adornData(ids, false)
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      }
    }
  }
</script>
<style>
  .el-table .extend-row {
    background:#E0E0E0;
  }
</style>
